/*
 This file is part of GNU Taler
 (C) 2021-2024 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

/**
 *
 * @author Sebastian Javier Marchano (sebasjm)
 */

import {
  HttpStatusCode,
  TalerError,
  assertUnreachable
} from "@gnu-taler/taler-util";
import { Fragment, VNode, h } from "preact";
import { ErrorLoadingMerchant } from "../../../../components/ErrorLoadingMerchant.js";
import { Loading } from "../../../../components/exception/loading.js";
import { useInstanceScheduledReports } from "../../../../hooks/reports.js";
import { LoginPage } from "../../../login/index.js";
import { NotFoundPageOrAdminCreate } from "../../../notfound/index.js";
import { CardTable } from "./Table.js";

interface Props {
  onCreate: () => void;
  onSelect: (id: string) => void;
}

export default function ListScheduledReport({ onCreate, onSelect }: Props): VNode {
  const result = useInstanceScheduledReports();

  if (!result) return <Loading />;
  if (result instanceof TalerError) {
    return <ErrorLoadingMerchant error={result} />;
  }
  if (result.type === "fail") {
    switch (result.case) {
      case HttpStatusCode.NotFound: {
        return <NotFoundPageOrAdminCreate />;
      }
      case HttpStatusCode.Unauthorized: {
        return <LoginPage focus />;
      }
      default: {
        assertUnreachable(result);
      }
    }
  }

  return (
    <Fragment>

      <section class="section is-main-section">
        <CardTable
          reports={result.body.reports}
          onLoadMoreBefore={undefined} //result.isFirstPage ? undefined : result.loadFirst}
          onLoadMoreAfter={undefined} //result.isLastPage ? undefined : result.loadNext}
          onCreate={onCreate}
          onSelect={(e) => {
            onSelect(String(e.report_serial));
          }}
        />
      </section>
    </Fragment>
  );
}
